import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/testimony/page.tsx");
